import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import * as _ from 'lodash-es';

/**
 * Adj Prior Year Data service.
 * Replicates AdjPriorYearFactory: getScenario (e8m65o), getCurrencies (x1q2ya), updatePriorYearScenario (3jibvt).
 */
@Injectable({
  providedIn: 'root'
})
export class AdjPriorYearDataService {

  constructor(private http: HttpClient) {}

  getScenarios(
    baseUrl: string,
    pyGroupObjKey: string | number,
    globalService: any,
    filterParams: any = {}
  ): Observable<any[]> {
    const params: Record<string, string | number> = {
      action_code: 'e8m65o',
      group_obj_key: pyGroupObjKey ?? '',
      tax_year: filterParams?.tax_year ?? globalService?.globalParams?.tax_year ?? '',
      scenario: filterParams?.scenario ?? globalService?.globalParams?.scenario ?? '',
      jcd_key: globalService?.globalParams?.jcd_key === '' || globalService?.globalParams?.jcd_key == null ? 250 : globalService?.globalParams?.jcd_key
    };
    return this.loadJson(baseUrl, params);
  }

  getCurrencies(
    baseUrl: string,
    cyCurr: string,
    globalService: any,
    filterParams: any = {}
  ): Observable<any[]> {
    const params: Record<string, string | number> = {
      action_code: 'x1q2ya',
      tax_year: filterParams?.tax_year ?? globalService?.globalParams?.tax_year ?? '',
      scenario: filterParams?.scenario ?? globalService?.globalParams?.scenario ?? '',
      jcd_key: globalService?.globalParams?.jcd_key === '' || globalService?.globalParams?.jcd_key == null ? 250 : globalService?.globalParams?.jcd_key,
      cy_curr: cyCurr ?? ''
    };
    return this.loadJson(baseUrl, params);
  }

  updatePriorYearScenario(
    baseUrl: string,
    jsonSettings: object,
    details: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=3jibvt`;
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(details) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = 'Update Prior Year Scenario - FIR';
    if (params.jcd_key === '' || params.jcd_key == null) {
      params.jcd_key = '250';
    }
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  private loadJson(baseUrl: string, params: Record<string, unknown>): Observable<any[]> {
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const url = `${baseUrl}/loadJsonObject?${urlEncoded.toString()}`;
    return this.http.get<any>(url, { withCredentials: true }).pipe(
      map((data: any) => {
        if (data?.callSuccess !== '1') {
          return [];
        }
        const arr = data?.jsonObject;
        return Array.isArray(arr) ? arr : [];
      })
    );
  }
}
